import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMemberInfo } from 'src/utils/common';
import { logout } from 'src/fetch/member';
import MainMenu from 'src/components/molecules/menu/MainMenu';
import './style.scss';

interface Props {}

const MainGnb: FC<Props> = () => {
  const navigate = useNavigate();
  const member: any = getMemberInfo() || { name: '홍길동', co_id: 'A4321', acct_year: '2026' };
  const isLoggedIn = !!member?.name;

  const handleLogout = async () => {
    await logout();
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="_main_gnb">
      <div className="_main_div">
        <div className="_main_title" onClick={() => navigate('/main')}>
          <div className="_logo">
            <img src="/temp/images/logo_def.png" />
          </div>
          <div className="_title_div">
            <div className="_title">YEBI</div>
            <div className="_desc">tax adjusment</div>
          </div>
        </div>
        <div className="_main_menu">
          <MainMenu />
        </div>
        <div className="_user_div">
          {isLoggedIn ? (
            <>
              <div className="_user_info">
                <div className="_avatar">
                  <span>{member.name?.charAt(0)}</span>
                </div>
                <div className="_info">
                  <div className="_name">{member.name}</div>
                  <div className="_sub">
                    {member.co_id} · {member.acct_year}년
                  </div>
                </div>
              </div>
              <button className="_btn _logout" onClick={handleLogout}>
                <i className="ri-logout-box-r-line" />
                {/* <span>로그아웃</span> */}
              </button>
            </>
          ) : (
            ''
            // <button className="_btn _login" onClick={handleLogin}>
            //   <i className="ri-login-box-line" />
            //   <span>로그인</span>
            // </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MainGnb;
